import React, { createContext, useContext, useEffect, useState } from 'react';

import ApplicationLoader from '../presentation/components/ApplicationLoader/ApplicationLoader';
import { useAuthStore } from '../stores/authStore';

interface LoaderContextType {
  loading: boolean;
  setLoading: (loading: boolean) => void;
}

const ApplicationLoaderContext = createContext<LoaderContextType | null>(null);

export const useLoader = () => {
  const context = useContext(ApplicationLoaderContext);
  if (!context) {
    throw new Error(
      'useLoader must be used within an ApplicationLoaderProvider'
    );
  }
  return context;
};

interface ApplicationLoaderProviderProps {
  children: React.ReactNode;
}

export const ApplicationLoaderProvider: React.FC<
  ApplicationLoaderProviderProps
> = ({ children }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const isAuthLoading = useAuthStore((state) => state.loading);

  useEffect(() => {
    setLoading(isAuthLoading);
  }, [isAuthLoading]);

  return (
    <ApplicationLoaderContext.Provider value={{ loading, setLoading }}>
      {loading ? <ApplicationLoader /> : children}
    </ApplicationLoaderContext.Provider>
  );
};
